import { CountryService } from 'src/app/_services/country.service';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index-country',
  templateUrl: './index-country.component.html',
  styleUrls: ['./index-country.component.css']
})
export class IndexCountryComponent implements OnInit {
    countryList=undefined
    loading = true
    constructor(private countryService:CountryService) { }

    ngOnInit(): void {

      this.countryService.getCountries().subscribe(
        x=>{
          this.countryList=x
          this.loading=false
        }
      )
      }


  }
